const env = process.env.CONFIG_FILE
var urls = {}

// support individual dev environments. If one is detected, replace URLs according to the convention.
if (env === "development" && (window.location.hostname.endsWith(".dev-env.hackedu.dev") ||
    window.location.hostname.endsWith("-www-app.env.hackedu.dev") )) {
    let name = window.location.hostname.split(".")[0].replace('-www-app', '')
    urls = {
        app: "https://" + window.location.host,
        controlK8s: `https://${name}-api-sandbox-ingress.env.hackedu.dev`,
        hacker: `https://${name}-api-hacker.env.hackedu.dev/hacker/v2`,
        linter: `https://${name}-api-linter.env.hackedu.dev/linter/v2`,
        rewards: `https://${name}-rewards.env.hackedu.dev`,
    }
}

module.exports = {urls}
